import { render } from "./ColorPresentation.vue?vue&type=template&id=66901d56"
import script from "./ColorPresentation.vue?vue&type=script&lang=js"
export * from "./ColorPresentation.vue?vue&type=script&lang=js"

import "./ColorPresentation.vue?vue&type=style&index=0&id=66901d56&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__